import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { SearchBar, PreparePackageTable } from './components';
import { childrenAttendTrackPageBreadcrumbs } from './config';
import { usePreparePackageFilter } from './hooks';

export const PreparePackage = () => {
  const { initialFilter, filter, setFilter } = usePreparePackageFilter();

  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => childrenAttendTrackPageBreadcrumbs(navigate),
    []
  );

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks breadcrumbs={breadcrumbs} actualPage='Preparar paquete' />
      <SearchBar
        initialFilter={initialFilter}
        filter={filter}
        search={setFilter}
      />
      <PreparePackageTable filter={filter} />
    </section>
  );
};

export default PreparePackage;
